module.exports = __webpack_public_path__ + "static/media/Footer-Mobile.8ac37ad2.jpg";